// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
const regeneratorRuntime = require("regenerator-runtime");
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'

import { store } from './store/store'
import Vuelidate from 'vuelidate'
import Notifications from 'vue-notification'
import { ClientTable } from 'vue-tables-2';

import underscore from 'vue-underscore';

import Quill from 'quill';
import VueQuillEditor from 'vue-quill-editor'
import VueCroppie from 'vue-croppie'

// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { ImageDrop } from 'quill-image-drop-module';
import { ImageResize } from 'quill-image-resize-module';
Quill.register('modules/imageDrop', ImageDrop);
Quill.register('modules/imageResize', ImageResize);

// todo
// cssVars()
import VueHtml2Canvas from 'vue-html2canvas';
Vue.use(VueHtml2Canvas);


Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(Notifications)
Vue.use(ClientTable)
Vue.use(underscore)
Vue.use(VueQuillEditor, /* { default global options } */ )
Vue.use(VueCroppie)


/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    template: '<App/>',
    store,
    components: {
        App
    }
})
